import React from 'react';
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_delivery-desk-12/artifacts/76spvmi3_3D4A54DE-AC29-47B8-ABEA-5150F325A161.png';

const Footer = () => {
  return (
    <footer className="bg-[#0B1B3A] text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 pb-12 border-b border-white/10">
          <div className="lg:col-span-2">
            <img src={LOGO_URL} alt="In'Nova Envios" className="h-20 mb-5" />
            <p className="text-sm text-slate-400 max-w-sm leading-relaxed">
              O jeito inteligente de enviar. Calcule e emita fretes dos Correios com desconto, para todo o Brasil. Sem mensalidades, sem burocracia.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Sobre</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/#como-funciona" className="hover:text-[#F77820]">Como funciona</a></li>
              <li><a href="/#beneficios" className="hover:text-[#F77820]">Vantagens</a></li>
              <li><a href="/calcular" className="hover:text-[#F77820]">Calcular frete</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Ajuda</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/#faq" className="hover:text-[#F77820]">Dúvidas frequentes</a></li>
              <li><a href="/regras-de-envio" className="hover:text-[#F77820]">O que pode enviar</a></li>
              <li><a href="/login" className="hover:text-[#F77820]">Entrar</a></li>
              <li><a href="/cadastro" className="hover:text-[#F77820]">Criar conta</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Fale com a gente</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="mailto:suporte@innovaenvios.app" className="hover:text-[#F77820] break-all">suporte@innovaenvios.app</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-slate-500">
          <p>{new Date().getFullYear()} © In&apos;Nova Envios — Desenvolvido por <strong>In&apos;Nova Art and Sciences</strong> | Todos os direitos reservados</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
